import createService from '../createService';
import { utilsBaseUrl } from '../apiBaseUrl';

export default createService({
  method: 'POST',
  baseUrl: utilsBaseUrl,
  pathTemplate: '/furtherLink/DNS',
});
